export default "__VITE_ASSET__a5444313__"